import { createAsyncThunk } from "@reduxjs/toolkit";
import { loadingActions } from "../LoaderSlice";
import { modalActions } from "../ModalSlice";
import {
  ATTENDANCE_API_URL,
  LEAVE_API_URL,
  JEDI_HR_URL,
} from "../../constants";
import axiosClient from "../../utils/axiosClient";
import axios from "axios";

// CALENDAR API'S
export const getCalendarData = createAsyncThunk(
  "attendance/calender_view",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getCalendarData : ", payload);

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/calender_view";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log(
        "getCalendarData response : ",
        response.data,
        typeof response.data,
      );

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getCalendarData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const getTruIdStatus = createAsyncThunk(
  "attendance/truid_status",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getTruIdStatus : ", payload);

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/truid_status";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log(
        "getTruIdStatus response : ",
        response.data,
        typeof response.data,
      );

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getTruIdStatus : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const getDashboardOverview = createAsyncThunk(
  "attendance/employee_overview",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getDashboardOverview : ", payload);
    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/employee_overview";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log(
        "getDashboardOverview response : ",
        response.data,
        typeof response.data,
      );

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getDashboardOverview : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

// get teams details for emp data thunk funtion
export const getTeamDetailData = createAsyncThunk(
  "attendance/team_details",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getTeamDetailData : ", payload);

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/team_details";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log(
        "getTeamDetailData response : ",
        response.data,
        typeof response.data,
      );

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getTeamDetailData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

// REGULARISATION API'S

export const regularisationHistory = createAsyncThunk(
  "attendance/emp_approval_status",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside regularisationHistory : ", payload);

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/emp_approval_status";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("regularisationHistory response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getCalendarData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
export const submitRegularisation = createAsyncThunk(
  "attendance/regularisation",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside submitRegularisation : ", payload);

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/regularisation";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("submitRegularisation response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getCalendarData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
export const regularisationApprovalList = createAsyncThunk(
  "attendance/regularize/manager_approval_status",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside regularisationApprovalList : ", payload);

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/manager_approval_status";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("regularisationApprovalList response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getCalendarData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
export const updateRegularisationApproval = createAsyncThunk(
  "attendance/update_approval_status",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside updateRegularisationApproval : ", payload);

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/update_approval_status";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("updateRegularisationApproval response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getCalendarData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
export const uploadRegularisationFileWithPresignedUrl = createAsyncThunk(
  "attendance/regularisation/get_pre_url",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside uploadFileWithPresignedUrl : ", payload);

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/get_pre_url";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, {
        employee_id: payload.employee_id,
        filename: payload?.filename,
      });

      // dispatch(loadingActions.setLoading(false));
      console.log("uploadFileWithPresignedUrl response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      const fileUploadData = new FormData();
      Object.keys(response?.data?.body?.fields).forEach((key) => {
        fileUploadData.append(key, response?.data?.body.fields[key]);
      });
      fileUploadData.append("file", payload.file);
      const fileUploadResponse = await axios.post(
        response?.data?.body.url,
        fileUploadData,
      );

      if (fileUploadResponse.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message: "Error : " + fileUploadResponse?.data?.error_message,
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          fileUploadResponse?.data?.error_message ||
            fileUploadResponse?.data?.message,
        );
      }

      return {
        key: payload.key,
        presignedUrlResponse: response?.data?.presigned_url,
        response: fileUploadResponse.data,
      };
    } catch (error) {
      console.log("Error :  ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

// LEAVE API'S

export const getLeaveStatusData = createAsyncThunk(
  "attendance/leave_approval_status",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside leaveapprovaldata : ", payload);

    const baseURL = "https://" + LEAVE_API_URL;

    const path = "/leave_approval_status";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("leaveapprovaldata response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error leaveapprovaldata : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
export const uploadLeaveFileWithPresignedUrl = createAsyncThunk(
  "attendance/leave/get_pre_url",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside uploadFileWithPresignedUrl : ", payload);

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/get_pre_url";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, {
        employee_id: payload.employee_id,
        filename: payload?.filename,
      });

      // dispatch(loadingActions.setLoading(false));
      console.log("uploadFileWithPresignedUrl response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      const fileUploadData = new FormData();
      Object.keys(response?.data?.body?.fields).forEach((key) => {
        fileUploadData.append(key, response?.data?.body.fields[key]);
      });
      fileUploadData.append("file", payload.file);
      const fileUploadResponse = await axios.post(
        response?.data?.body.url,
        fileUploadData,
      );

      if (fileUploadResponse.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message: "Error : " + fileUploadResponse?.data?.error_message,
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          fileUploadResponse?.data?.error_message ||
            fileUploadResponse?.data?.message,
        );
      }

      return {
        key: payload.key,
        presignedUrlResponse: response?.data?.presigned_url,
        response: fileUploadResponse.data,
      };
    } catch (error) {
      console.log("Error :  ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
export const getLeaveDetails = createAsyncThunk(
  "attendance/get_leave_data",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getLeaveDetails : ", payload);

    const baseURL = "https://" + LEAVE_API_URL;

    const path = "/get_leave_data";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("getLeaveDetails response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getCalendarData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const getLeaveCountBetweenDates = createAsyncThunk(
  "attendance/total_days",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getLeaveCountBetweenDates : ", payload);

    const baseURL = "https://" + LEAVE_API_URL;

    const path = "/total_days";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("getLeaveCountBetweenDates response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getLeaveCountBetweenDates : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const submitLeave = createAsyncThunk(
  "attendance/apply_leave",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside submitLeave : ", payload);

    const baseURL = "https://" + LEAVE_API_URL;

    const path = "/apply_leave";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("submitLeave response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getCalendarData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
export const pendingLeaveApprovals = createAsyncThunk(
  "attendance/leave/manager_approval_status",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside pendingLeaveApprovals : ", payload);

    const baseURL = "https://" + LEAVE_API_URL;

    const path = "/manager_approval_status";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("pendingLeaveApprovals response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getCalendarData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
export const approvedLeaves = createAsyncThunk(
  "attendance/approved_requests",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside approvedLeaves : ", payload);

    const baseURL = "https://" + LEAVE_API_URL;

    const path = "/approved_requests";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("approvedLeaves response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getCalendarData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
export const updateLeaveApprovals = createAsyncThunk(
  "attendance/leave/update_approval_status",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside updateLeaveApprovals : ", payload);

    const baseURL = "https://" + LEAVE_API_URL;

    const path = "/update_approval_status";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("updateLeaveApprovals response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getCalendarData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

// get team details view for manager thunk function

export const getTeamDetailManagerData = createAsyncThunk(
  "attendance/team_details_manager",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    // console.log("\n\nInside getTeamDetailManagerData : ", payload);

    let apiPayload = { ...payload };
    if (apiPayload.status === "all") {
      apiPayload.status = "";
    }

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/view_loggedin_users";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, apiPayload);

      // dispatch(loadingActions.setLoading(false));
      // console.log("getTeamDetailManagerData response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getTeamDetailManagerData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

// filter of team details manager thunk function

export const getFilteredTeamData = createAsyncThunk(
  "attendance/filteredTeam_manager_data",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    // console.log("\n\nInside getFilteredTeamData : ", payload);

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/filters";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      // console.log("getFilteredTeamData response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getFilteredTeamData : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const getManagerReportDownload = createAsyncThunk(
  "attendance/manager_report_download",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    // console.log("\n\nInside getManagerReportDownload : ", payload);

    let apiPayload = { ...payload };
    if (apiPayload.status === "all") {
      apiPayload.status = "";
    }

    const baseURL = "https://" + ATTENDANCE_API_URL;

    const path = "/view_loggedin_users";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, apiPayload);

      // dispatch(loadingActions.setLoading(false));
      // console.log("getManagerReportDownload response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error :" +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getManagerReportDownload : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
